// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  waypointId: __t.u64().primaryKey().name("waypoint_id"),
  owner: __t.identity(),
  worldId: __t.u64().name("world_id"),
  name: __t.string(),
  posX: __t.f32().name("pos_x"),
  posZ: __t.f32().name("pos_z"),
  createdAt: __t.timestamp().name("created_at"),
});
